// Simulated "now playing" rotation. NOTE: this is NOT a live Spotify feed.
// It shuffles this list to feel real-time. Swap these for the songs you
// actually listen to (title + artist). A genuine live feed would need the
// Spotify Web API (OAuth) + a small backend endpoint.

export const tracks = [
  // hip-hop / rap
  { title: "HUMBLE.", artist: "Kendrick Lamar", len: 177 },
  { title: "God's Plan", artist: "Drake", len: 199 },
  { title: "SICKO MODE", artist: "Travis Scott", len: 312 },
  { title: "No Role Modelz", artist: "J. Cole", len: 292 },
  { title: "Lose Yourself", artist: "Eminem", len: 326 },
  { title: "Money Trees", artist: "Kendrick Lamar", len: 386 },
  // bangla / desi
  { title: "Nasek Nasek", artist: "Coke Studio Bangla", len: 268 },
  { title: "Oniket Prantor", artist: "Artcell", len: 384 },
  { title: "Purnota", artist: "Warfaze", len: 311 },
  { title: "Brown Munde", artist: "AP Dhillon", len: 200 },
  { title: "Kesariya", artist: "Arijit Singh", len: 268 },
  { title: "Mirchi", artist: "Divine", len: 215 },
  // pop / r&b
  { title: "Blinding Lights", artist: "The Weeknd", len: 200 },
  { title: "Levitating", artist: "Dua Lipa", len: 203 },
  { title: "Snooze", artist: "SZA", len: 202 },
  { title: "That's What I Like", artist: "Bruno Mars", len: 206 },
  { title: "Pink + White", artist: "Frank Ocean", len: 184 },
  { title: "As It Was", artist: "Harry Styles", len: 167 },
];
